import React, { useState } from 'react';
import "./SubNavbar.css";

const SubNavbar = ({ setPage, options }) => {
    const [selectedPage, setSelectedPage] = useState(options[0]);

    function goToPage(page) {
        setSelectedPage(page);
        setPage(page);
    }

    return (
        <nav className='navbar'>
            <ul>
                {options && options.map(option=>{return (
                    <li className={selectedPage === option ? 'selected': ""} onClick={() => goToPage(option)}>{option[0].toUpperCase() + option.slice(1)}</li>)})}
            </ul>
        </nav>
    );
};

export default SubNavbar;